/**
 * Provides a nicer interface to access the Data which was
 * provided server side.
 *
 * You can access through window.RailsData... but using this
 * method makes it much cleaner.
 *
 * @param path
 * @returns {*}
 */
export default function railsData(path = '') {
  let result = null;
  let data = window.RailsData;

  path.split('.').forEach(key => {
    if (!data) {
      return;
    }

    result = data[key];
    data = data[key];
  });

  return result;
}
